import { typeaheadCheck } from '../utils';
import { productLinkBuilder } from 'common-ui';
import { RecommendedItem } from '../productCard/recommendedItem';
import type { GetSourcesParams, OnSelectParams } from '@algolia/autocomplete-core';
import type { BaseItem } from './types';
import { storeQueryIDForProduct } from '../../../utils';

// Define the type for the recommendation item
interface RecommendationItem {
  productName: string;
  vintage: string;
  itemCode: string;
  productSlug?: string;
  giftFlag: boolean;
  productType: string;
  productWebType: string;
  country: string;
  grape: string;
  skus: any[];
  preSell: boolean;
  enPrimeur: boolean;
  __autocomplete_indexName?: string;
}

const RecommendPluginHeader = () => <span className="aa-SourceHeaderTitle"> Recommended </span>;
const RecommendedPluginItem = ({ item, components }: any) => <RecommendedItem hit={item} components={components} />;

export function createRecommendPlugin() {
  return {
    getSources({ query: sourceQuery, state }: GetSourcesParams<BaseItem>) {
      if (!sourceQuery || !typeaheadCheck(sourceQuery)) {
        return [];
      }

      return [
        {
          sourceId: 'recommendPlugin',
          getItems() {
            const context = state.context as { topHit?: RecommendationItem };

            // Check if topHit exists in the context and return it for recommendations
            if (context?.topHit) {
              const {
                productName,
                vintage,
                itemCode,
                productSlug,
                giftFlag,
                productType,
                productWebType,
                country,
                grape,
                skus,
                preSell,
                enPrimeur,
              } = context.topHit;

              return [
                {
                  productName,
                  vintage,
                  itemCode,
                  productSlug,
                  giftFlag,
                  productType,
                  productWebType,
                  country,
                  grape,
                  skus,
                  preSell,
                  enPrimeur,
                },
              ];
            }

            // Fallback if no topHit is available
            return [];
          },
          onSelect({ item, state: selectState }: OnSelectParams<BaseItem>) {
            if (!item?.productSlug || !item?.itemCode) {
              return;
            }

            const context = selectState.context as { queryID?: string | number; topHit?: RecommendationItem };

            storeQueryIDForProduct(
              item?.itemCode as string,
              context.queryID?.toString() as string,
              0,
              context?.topHit?.__autocomplete_indexName as string,
            );

            window.location.href = productLinkBuilder(item?.productSlug as string, item?.itemCode as string);
          },
          templates: {
            header: RecommendPluginHeader,
            item: RecommendedPluginItem,
          },
        },
      ];
    },
  };
}
